import React, { useState } from "react";
import { AiOutlineProduct } from "react-icons/ai";
import { BiCategory, BiSolidOffer } from "react-icons/bi";
import { FaDashcube, FaRegUser, FaSearchengin, FaSitemap, FaUserCog } from "react-icons/fa";
import { FaVideo, FaNewspaper, FaPhone, FaComments} from "react-icons/fa"; // Add these imports
import { GrServices } from "react-icons/gr";
import { SiGoogleads, SiSpeedtest } from "react-icons/si";

import { MdAttribution, MdOutlineBrandingWatermark } from "react-icons/md";
import { TbLogs } from "react-icons/tb";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "../../styles/Sidebar.css";
import { Eye, ListChecks, Mic2Icon } from "lucide-react";
import { MdDynamicForm } from "react-icons/md"; // icon for dynamic pages
import { HiTemplate } from "react-icons/hi";
import { PiFlagBannerFold } from "react-icons/pi";
import { VscLayoutMenubar } from "react-icons/vsc";
import { SiCreatereactapp } from "react-icons/si";


const links = [
  { to: "/home", label: "Dashboard", icon: <FaDashcube /> },
  { to: "/userManagement", label: "Users", icon: <FaRegUser /> },
  {
    label: "Blogs",
    icon: <TbLogs />,
    sublinks: [
      { to: "/blogManagement", label: "Blog Listing", icon: <TbLogs /> },
      { to: "/blog-category", label: "Blog Categories", icon: <BiCategory /> },
      { to: "/generatetemplate", label: "Generate Template", icon : <HiTemplate />}
    ],
  },
  {
    to: "/companyManagement",
    label: "Brands",
    icon: <MdOutlineBrandingWatermark />,
  },
  { to: "/vendors", label: "Vendors", icon: <FaUserCog /> },
  {
    label: "Products",
    icon: <AiOutlineProduct />,
    sublinks: [
      { to: "/products", label: "Product Listing", icon: <AiOutlineProduct /> },
      {
        to: "/product-category",
        label: "Product Categories",
        icon: <BiCategory />,
      },
    ],
  },
  {
    label: "Inquiries",
    icon: <FaSearchengin  />,
    sublinks: [
      { to: "/contactus", label: "Contact Us", icon: <FaPhone /> },
      { to: "/requirement ", label: "Requirement", icon: <ListChecks /> },

    ],
  },
  { to: "/attribute", label: "Attributes", icon: <MdAttribution /> },
  { to: "/questions", label: "Q&A", icon: <FaComments  /> },
  { to: "/services", label: "Services", icon: <GrServices /> },
  { to: "/news", label: "News", icon: <FaNewspaper /> },
  { to: "/videos", label: "Videos", icon: <FaVideo /> },
  { to: "/Comments", label: "Comments", icon:<FaComments  /> },
  { to: "/reviews", label: "Reviews", icon: <Eye/> },
  { to: "/marketplace ", label: "Marketplace", icon: <GrServices /> },
  { to: "/interview ", label: "Interviews", icon: <Mic2Icon /> },
  { to: "/sitemap ", label: "Sitemap", icon: <FaSitemap /> },
  { to: "/offers ", label: "Offers", icon: <BiSolidOffer /> },
  { to: "/ads ", label: "Ads", icon: <SiGoogleads/> },
  { to: "/testimonial ", label: "TestiMonial", icon: <SiSpeedtest/> },
  { to:"/dynamic-pages", label: "Dynamic Pages", icon: <MdDynamicForm /> },
  { to: "/banner-manager", label: "Banner Manager", icon: <PiFlagBannerFold /> },
  { to: "/header-links-manager", label: "Header Links Manager", icon: <VscLayoutMenubar /> },
  { to: "/page-builder", label: "Page Builder", icon: <SiCreatereactapp /> },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  
  const [openLinks, setOpenLinks] = useState({});

  const toggleSublinks = (label) => {
    setOpenLinks((prevOpenLinks) => ({
      ...prevOpenLinks,
      [label]: !prevOpenLinks[label],
    }));
  };

  return (
    <div className="sidebar-container bg-[#1c2434] p-[10px]">
      <h1
        className="text-white text-[24px] mb-[20px] cursor-pointer"
        onClick={() => navigate("/home")}
      >
        Solar Station
      </h1>

      {links.map((link, index) => (
        <div key={index}>
          {/* Main Link */}
          <div
            onClick={() =>
              link.sublinks ? toggleSublinks(link.label) : navigate(link.to)
            }
          >
            <NavLink
              to={link.to}
              className={({ isActive }) =>
                isActive && location.pathname === link.to
                  ? "sidebar-link active"
                  : "sidebar-link"
              }
            >
              <span>{link.icon}</span>
              <span>{link.label}</span>
            </NavLink>
          </div>

          {link.sublinks && openLinks[link.label] && (
            <div className="sublinks pl-[20px]">
              {link.sublinks.map((sublink, subIndex) => (
                <NavLink
                  key={subIndex}
                  to={sublink.to}
                  className={({ isActive }) =>
                    isActive && location.pathname === sublink.to
                      ? "sidebar-link active"
                      : "sidebar-link"
                  }
                >
                  <span>{sublink.icon}</span>
                  <span>{sublink.label}</span>
                </NavLink>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
